import React from 'react'

const RoundCheckIcon = () => {
    return (
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2_3108)">
                <path d="M5.5 0C2.4599 0 0 2.46015 0 5.5C0 8.5401 2.46015 11 5.5 11C8.5401 11 11 8.53985 11 5.5C11 2.4599 8.53985 0 5.5 0ZM5.5 10.2667C2.87167 10.2667 0.733326 8.12836 0.733326 5.5C0.733326 2.87164 2.87167 0.733326 5.5 0.733326C8.12833 0.733326 10.2667 2.87167 10.2667 5.5C10.2667 8.12833 8.12833 10.2667 5.5 10.2667Z" fill="black" />
                <path d="M8.41075 3.4824C8.26756 3.3392 8.03538 3.3392 7.89221 3.4824L4.62793 6.74667L3.10641 5.22516C2.96322 5.08197 2.73104 5.08197 2.58786 5.22516C2.44467 5.36836 2.44467 5.60052 2.58786 5.74371L4.36864 7.52449C4.51181 7.66766 4.74406 7.66762 4.88719 7.52449L8.41075 4.00092C8.55395 3.85773 8.55395 3.62559 8.41075 3.4824Z" fill="black" />
            </g>
            <defs>
                <clipPath id="clip0_2_3108">
                    <rect width="11" height="11" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default RoundCheckIcon